export const REPORT_FILE_EXTENSION = {
  PDF: 'pdf',
  XLSX: 'xlsx',
  XLS: 'xls',
} as const

export const REPORT_FILE_EXTENSIONS = Object.values(REPORT_FILE_EXTENSION)

export const REPORT_ASSESSMENT_DATE = {
  ALL: 'All',
  FULL: 'Full Assessment',
  WEEKLY: 'Weekly updated',
} as const

export const REPORT_ASSESSMENT_DATES_WITH_ALL = Object.values(
  REPORT_ASSESSMENT_DATE,
)

export const REPORT_ASSESSMENT_DATES = REPORT_ASSESSMENT_DATES_WITH_ALL.filter(
  (date) => date !== REPORT_ASSESSMENT_DATE.ALL,
)

export const REPORT_TAG_VIDEO_INTRO = {
  SUSTAINABILITY: 'esg-video-intro',
  FORECASTS: 'forecast-video-intro',
} as const

export const REPORT_TAGS_VIDEO_INTRO = Object.values(REPORT_TAG_VIDEO_INTRO)

export const REPORT_TAG = {
  ESG_VIDEO: 'esg-video',
  FORECASTS_VIDEO: 'forecast-video',
} as const

export const REPORT_ALL_TAGS = Object.values(REPORT_TAG)
export const REPORT_TAGS = REPORT_ALL_TAGS.filter(
  (tag) => tag !== REPORT_TAG.FORECASTS_VIDEO,
)
